      <div  class="modal-header">
         <div class="title-section">
            <h2>Assign New Goal(s)</h2>
            <p>Enable the goals & corresponding targets below that you would like to assign to this hospital. Press the
               save button when complete.</p>
         </div>
         <span class="material-icons close-icon" (click)="onClose()">
            close
         </span>
      </div>
   <mat-dialog-content>
            <div class="modal-body">
         <form class="form-body" autofocus="false" autocomplete="off">
            <div class="form-row" style="display: flex; gap: 16px; align-items: flex-end;">
               <mat-form-field class="form-field" [autofocus]="false" appearance="outline" style="flex: 1; min-width: 400px;">
                  <mat-label>Hospital</mat-label>
                  <input type="text" matInput [(ngModel)]="selectedHospital" name="hospital"
                     [matAutocomplete]="autoHospital" (ngModelChange)="onHospitalChange($event)">
                  <button *ngIf="selectedHospital" mat-icon-button matSuffix aria-label="Clear"
                     (click)="resetAllValues(); $event.stopPropagation();">
                     <mat-icon>close</mat-icon>
                  </button>
                  <mat-autocomplete  #autoHospital="matAutocomplete">
                     <mat-option *ngFor="let h of filteredHospitals" [value]="h.practiceName">
                        {{h.practiceName}}
                     </mat-option>
                  </mat-autocomplete>
               </mat-form-field>
               <!-- Quarter Autocomplete -->
               <mat-form-field class="form-field" appearance="outline" style="flex: 1; min-width: 200px;">
                  <mat-label>Quarter</mat-label>
                  <input type="text" matInput [(ngModel)]="selectedQuarter" name="quarter"
                     [matAutocomplete]="autoQuarter">
                  <button *ngIf="selectedQuarter" mat-icon-button matSuffix aria-label="Clear"
                     (click)="resetAllValues(); $event.stopPropagation();">
                     <mat-icon>close</mat-icon>
                  </button>
                  <mat-autocomplete #autoQuarter="matAutocomplete">
                     <mat-option *ngFor="let q of quarterList" [value]="q.quarterName">
                        {{q.quarterName}}
                     </mat-option>
                  </mat-autocomplete>
               </mat-form-field>
            </div>
         </form>
      </div>
   </mat-dialog-content>


      <div class="modal-footer">
         <button class="cancel-btn" (click)="onClose()">
            Cancel
         </button>
         <button [disabled]="!selectedHospital || !selectedQuarter"
            (click)="newAssginGoalPage()" class="next-btn"
            [ngClass]="{'next-btn-disabled': !selectedHospital || !selectedQuarter}">Next</button>
      </div>